/**
 * Refresh Event Store
 *
 * 集中管理数据刷新事件的 Zustand store
 * 使用递增计数器模式触发组件刷新，避免事件丢失
 */

import { create } from 'zustand';

interface RefreshState {
  // 事件计数器（递增触发刷新）
  settingsRefreshKey: number;
  chaptersRefreshKey: number;

  // 最新更新的项 ID（用于选择性刷新）
  lastUpdatedSettingId: number | null;
  lastUpdatedChapterId: number | null;

  // 触发刷新方法
  triggerSettingsRefresh: (settingId?: number) => void;
  triggerChaptersRefresh: (chapterId?: number) => void;
  clearUpdatedIds: () => void;
}

export const useRefreshStore = create<RefreshState>((set) => ({
  settingsRefreshKey: 0,
  chaptersRefreshKey: 0,
  lastUpdatedSettingId: null,
  lastUpdatedChapterId: null,

  triggerSettingsRefresh: (settingId?: number) => set((state) => ({
    settingsRefreshKey: state.settingsRefreshKey + 1,
    lastUpdatedSettingId: settingId ?? null,
  })),

  triggerChaptersRefresh: (chapterId?: number) => set((state) => ({
    chaptersRefreshKey: state.chaptersRefreshKey + 1,
    lastUpdatedChapterId: chapterId ?? null,
  })),

  clearUpdatedIds: () => set({
    lastUpdatedSettingId: null,
    lastUpdatedChapterId: null,
  }),
}));
